import type { Language } from "@app/constants";

interface Message {
	header: string;
	update: string;
	closeModal: string;
}

type MessageData = {
	[key in Language]: Message;
};

const messages: MessageData = {
	en: {
		header: "Your Kraken Account is already linked.",
		update:
			"If you need to update it, please get in touch with your Relationship Manager, ",
		closeModal: "Close",
	},
};

export default messages;
